// External Libraries
import React from 'react';

// Styles
import '../../styles/ConfirmationModal.css';

// Components
import Button from './Button';
import Text from './Text';

interface GenericConfirmationModalProps {
  isOpen: boolean;
  message: string;
  onFirstButtonAction: () => void;
  onFirstButtonName: string;
  onSecondButtonAction: () => void;
  onSecondButtonName: string;
}

const GenericConfirmationModal: React.FC<GenericConfirmationModalProps> = ({
  isOpen,
  message,
  onFirstButtonAction,
  onFirstButtonName,
  onSecondButtonAction,
  onSecondButtonName,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fullscreen-overlay">
      <div className="dialog-box grid gap-20">
        <div className="grid gap-10">
          <Text className="brand-title">Confirmation</Text>
          <Text>{message}</Text>
        </div>
        <div className="grid gap-10">
          <Button
            type="button"
            className="primary-button"
            onClick={onFirstButtonAction}
          >
            {onFirstButtonName}
          </Button>
          <Button
            type="button"
            className="primary-button"
            onClick={onSecondButtonAction}
          >
            {onSecondButtonName}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default GenericConfirmationModal;
